import { ActionType, createAction } from "typesafe-actions"
import { RequestState } from "../../constants/request-state";
import { EvalDataItem } from "../../types/eval/EvalDataItem";
import { EvalOrderByColumn } from "../../types/state/entities/EvalState";

const init = createAction("entities/eval/INIT",
    resolve => (sortField: EvalOrderByColumn, sortDirection: string) =>
        resolve({ sortField, sortDirection })
);
const request = createAction("entities/eval/REQUEST",
    resolve => (sortField: EvalOrderByColumn, sortDirection: string, applyFilter: boolean = true) =>
        resolve({ sortField, sortDirection, applyFilter })
);
const requestStateChange = createAction("entities/eval/REQUEST_STATE_CHANGE",
    resolve => (requestState: RequestState) => resolve({ requestState })
);
const requestResult = createAction("entities/eval/REQUEST_RESULT",
    resolve => (requestState: RequestState, result: EvalDataItem[] = [], totalRecordNumber: number = 0) =>
        resolve({ requestState, result, totalRecordNumber })
);
const loadNextPage = createAction('entities/eval/LOAD_NEXT_PAGE');
const reset = createAction('entities/eval/RESET');
const exportData = createAction('eval/EXPORT',
    resolve => (sortField: EvalOrderByColumn, sortDirection: string) =>
        resolve({ sortField, sortDirection })
);
const exportRequestStateChange = createAction("entities/eval/EXPORT_REQUEST_STATE_CHANGE",
    resolve => (requestState: RequestState) => resolve({ requestState })
);

export type EvalActionType = ActionType<typeof evalActions[keyof typeof evalActions]>

export const evalActions = {
    init,
    request,
    requestStateChange,
    requestResult,
    loadNextPage,
    exportData,
    exportRequestStateChange,
    reset
}